const initAppAction = ({ commit }, payload) => {
  commit("setState", payload);
};

const showMoreAction = ({ commit, state }, payload) => {
  const { posts, postsPerPage, highlightNumber } = state;

  const start = payload * postsPerPage;
  const end = start + postsPerPage;

  commit("setPage", payload);
  commit("appendPills", posts.slice(highlightNumber).slice(start, end));
};

const actions = {
  initApp: initAppAction,
  showMore: showMoreAction,
};

export default actions;
